var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsTraining = function SvgFormsTraining(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.283 3.554a.569.569 0 00-.526.022.506.506 0 00-.257.435v2.478a.507.507 0 00.257.435.569.569 0 00.526.022l2.326-1.098a.653.653 0 000-1.196L8.283 3.554zM11.5 15h-5l.5-3h4l.5 3zM5 15h8M1.5 9.5h15",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1h15v11h-15V1z",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsTraining;